import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';

import { withFirebase } from '../Firebase';

const withTranslation = (Component) => {
  return (props) => {
    const { t } = useTranslation();
    return <Component {...props} t={t} />;
  };
};

class UserItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      user: null,
      ...props.location.state,
    };
  }

  componentDidMount() {
    if (this.state.user) {
      return;
    }

    this.setState({ loading: true });

    this.props.firebase
      .user(this.props.match.params.id)
      .on('value', snapshot => {
        this.setState({
          user: snapshot.val(),
          loading: false,
        });
      });
  }

  componentWillUnmount() {
    this.props.firebase.user(this.props.match.params.id).off();
  }

  onSendPasswordResetEmail = () => {
    this.props.firebase.doPasswordReset(this.state.user.email);
  };

  render() {
    const { user, loading } = this.state;
    const { t } = this.props;

    return (
      <div>
        {loading ? (
          <loader active inline="centered" />
        ) : (
          <article>
            <header>{t('users.user_label')}: {user.uid}</header>
            {user && (
              <div>
                <span>{t('users.username_label')}: {user.username}</span>
                <span>{user.email}</span>
                <br />
                <button
                  primary
                  type="button"
                  onClick={this.onSendPasswordResetEmail}
                >
                  {t('users.send_password_reset')}
                </button>

              </div>
            )}
          </article >
        )
        }
      </div>
    );
  }
}

export default withTranslation(withFirebase(UserItem));
